export type OptionType = {
  label: string;
  value: string;
  disabled?: boolean;
  translationTag?: string;
};

export type GroupOptionType = {
  label: string;
  value?: string;
  options: OptionType[];
  translationTag?: string;
};

export const toOption = (value: any, label: string, extra: object = {}): OptionType => ({
  value: String(value),
  label: label ?? String(value),
  ...extra,
});

export const ALL_OPTION = {
  value: 'all',
}

export const ANY_OPTION = {
  translationTag: 'FORM_FIELDS:ANY_OPTION',
  value: 'any',
}

export function getAnyOption(t: (s: string) => string) {
  return {
    label: t(ANY_OPTION.translationTag),
    value: ANY_OPTION.value,
  }
}

export function hasAnyOption(field: OptionType[]) {
  return field.find((f) => f.value === ANY_OPTION.value);
}

export default toOption;
